function initLottieSections() {
  document.querySelectorAll('[data-lottie-section]').forEach(function (section) {
    var playerId = section.getAttribute('data-lottie-player');
    var lottiePlayer = document.getElementById(playerId);
    if (!lottiePlayer) return;

    var isReady = false;
    var isVisible = false;

    var tryPlay = function () {
      if (isReady && isVisible) lottiePlayer.play();
    };

    var fixShadowDom = function () {
      if (lottiePlayer.shadowRoot) {
        var animationContainer = lottiePlayer.shadowRoot.querySelector('#animation');
        if (animationContainer) {
          animationContainer.style.width = 'fit-content';
          animationContainer.style.height = 'auto';
        }
      }
    };

    var observer = new IntersectionObserver(
      function (entries) {
        isVisible = entries[0].isIntersecting;
        if (isVisible) {
          tryPlay();
        } else {
          lottiePlayer.pause();
        }
      },
      { threshold: 0, rootMargin: '0px 0px -300px 0px' }
    );

    observer.observe(section);

    section.addEventListener(
      'touchstart',
      function () {
        if (!lottiePlayer.isPlaying) lottiePlayer.play();
      },
      { passive: true }
    );

    var onReady = function () {
      if (isReady) return;
      isReady = true;
      fixShadowDom();
      tryPlay();
    };

    lottiePlayer.addEventListener('ready', onReady);
    lottiePlayer.addEventListener('load', onReady);

    var state = lottiePlayer.currentState;
    if (state && state !== 'loading' && state !== '') {
      onReady();
    }
  });
}

if (window.customElements) {
  customElements.whenDefined('lottie-player').then(initLottieSections);
} else {
  document.addEventListener('DOMContentLoaded', initLottieSections);
}
